import cn from 'classnames'

import styles from './ConnectionIcon.module.scss'

type Props = {
  href: string
  isDisabled: boolean
  iconClassName: string
}

export const ConnectionIcon = ({ href, isDisabled, iconClassName }: Props) => {
  return (
    <a
      target="_blank"
      rel="noreferrer"
      href={href}
      className={cn({ [styles.disabled]: isDisabled })}
    >
      <i className={cn(styles.icon, iconClassName, { [styles.disabled]: isDisabled })} />
    </a>
  )
}
